
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree555"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree555"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hEplm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "auth", () => $cd99d4c69721859b$export$73693bad9f5880b0);
$parcel$export(module.exports, "db", () => $cd99d4c69721859b$export$f932f06c7eb6abeb);
$parcel$export(module.exports, "default", () => $cd99d4c69721859b$export$2e2bcd8739ae039);
parcelRequire("fhN3L");
var $7xvHX = parcelRequire("7xvHX");

var $6AR8M = parcelRequire("6AR8M");

var $ilpIi = parcelRequire("ilpIi");
const $cd99d4c69721859b$var$firebaseConfig = {
    apiKey: "SUA_API_KEY",
    authDomain: "SEU_AUTH_DOMAIN",
    projectId: "SEU_PROJECT_ID",
    storageBucket: "SEU_STORAGE_BUCKET",
    messagingSenderId: "SEU_MESSAGING_SENDER_ID",
    appId: "SEU_APP_ID"
};
const $cd99d4c69721859b$var$app = (0, $7xvHX.initializeApp)($cd99d4c69721859b$var$firebaseConfig, "padre-cacique");
const $cd99d4c69721859b$export$73693bad9f5880b0 = (0, $6AR8M.getAuth)($cd99d4c69721859b$var$app);
(0, $6AR8M.setPersistence)($cd99d4c69721859b$export$73693bad9f5880b0, (0, $6AR8M.browserLocalPersistence));
const $cd99d4c69721859b$export$f932f06c7eb6abeb = (0, $ilpIi.getFirestore)($cd99d4c69721859b$var$app);
var $cd99d4c69721859b$export$2e2bcd8739ae039 = $cd99d4c69721859b$var$app;

});
parcelRegister("fhN3L", function(module, exports) {
$parcel$export(module.exports, "getApp", () => (parcelRequire("7xvHX")).getApp);
$parcel$export(module.exports, "getApps", () => (parcelRequire("7xvHX")).getApps);
$parcel$export(module.exports, "initializeApp", () => (parcelRequire("7xvHX")).initializeApp);
$parcel$export(module.exports, "registerVersion", () => (parcelRequire("7xvHX")).registerVersion);

var $7xvHX = parcelRequire("7xvHX");
var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "10.14.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $7xvHX.registerVersion)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');

});



parcelRequire("hEplm");

//# sourceMappingURL=firebase-init-pc.49251f90.js.map
